export class TranslationNameView {
    id: number;
    name: string;
}